import { stringifyQuery } from './utils'
import env from './env'
import isPlainObject from 'lodash/isPlainObject'
import { store as commonAuthStore } from '@maui-mf/common-auth'

const AS_OPTIONS = ['arrayBuffer', 'blob', 'formData', 'json', 'text', false]

const INTEL_API_URL = env?.REACT_APP_API_HOST

export const mergeHeaders = (givenHeaders) => {
  const baseHeaders = {
    accept: 'application/json',
    'content-type': 'application/json',
  }

  if (!isPlainObject(givenHeaders)) {
    return baseHeaders
  }

  for (const key in givenHeaders) {
    const lowercaseKey = key.toLowerCase()

    if (givenHeaders[key] === false) {
      delete baseHeaders[lowercaseKey]
    } else {
      baseHeaders[lowercaseKey] = givenHeaders[key]
    }
  }

  return baseHeaders
}

export async function apiFetch(path, options = {}, host = INTEL_API_URL) {
  const {
    as = 'json',
    query,
    headers: givenHeaders = {},
    forceAuthorization = false,
    ...fetchOptions
  } = options

  if (!AS_OPTIONS.includes(as)) {
    throw new Error(`\`as\` option must be one of [${AS_OPTIONS.join(', ')}]`)
  }

  const fullpath = query ? `${path}?${stringifyQuery(query)}` : path

  const url = new URL(fullpath, host)
  const token = commonAuthStore.getValue()?.token
  const headers = mergeHeaders(givenHeaders)

  if (token) {
    headers.Authorization = `Bearer ${token}`
  } else if (forceAuthorization) {
    throw new Error('No token stored and forceAuthorization option given')
  }

  const mergedOptions = {
    method: 'GET',
    headers,
    ...fetchOptions,
  }

  const response = await fetch(url, mergedOptions)

  if (response.status >= 400) {
    const e = new Error(response.status)
    e.response = response
    e.status = response.status
    e.body = as ? await response[as]() : undefined
    throw e
  }

  if (response.status === 204) {
    throw new Error('No Content')
  }

  if (response.status === 201) {
    return response
  }

  return as ? response[as]() : response
}

export default {
  fetch: apiFetch,
}
